import { useState, useEffect } from 'react';
import Axios from "axios";
import { GetJobRoles, GetJobPosts,siteURL,updateStatus,GetCountries, Searchfilter,GetListOfVendorsByEmployeeID, UpdateCandidateClientStatus, GetListOfUsersWithAdminByEmployeeID } from '../../apiconstants/constants';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../../helpers/loadingspinner';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from '../../commonlayouts/consultantlayout';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../../contexts/countrycodecontext.js';
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}

const Reports = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'  
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [jobRoles, setJobRoles] = useState([]);
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showModal,setShowModal] = useState(false)
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [candidateId, setCandidateId] = useState(null);
  const [hasNoData, setHasNoData] = useState(false);
  const { selectedCountry} = useCountry();
  const [vendorData, setVendorData] = useState([]);
  const [selectedUserGuid, setSelectedUserGuid] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showDropdownModal, setShowDropdownModal] = useState(false);
  const [comments, setComments] = useState(""); // End date state
  const [submittedDate, setSubmittedDate] = useState();
    const [jobPosts, setJobPosts] = useState([]);
    const [selectedCandidateGuids, setSelectedCandidateGuids] = useState([]); // now only storing GUID strings
const [usersList, setUsersList] = useState([]);
const [originalCandidateData, setOriginalCandidateData] = useState([]);
const [selectedTile, setSelectedTile] = useState("reset");
const [baseFilteredData, setBaseFilteredData] = useState([]); 
  const [summaryData, setSummaryData] = useState({});
const token = localStorage.getItem("jwtToken"); 
const fetchJobPosts = async (JobRoleID, vendorGuid) => {
      setIsLoading(true);

      try {
        const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filter based on selected Job Role and Vendor (client)
        const filteredPosts = response.data.filter((x)=>x.status =='Active')
            console.log(filteredPosts)
    
        setJobPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching job posts", error);
      } finally {
        setIsLoading(false);
      }
    };
    console.log("46",selectedCountry)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
const fileName = "CandidatesList"; 
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")

const roleID = localStorage.getItem("roleID")
const appliedfilter = localStorage.getItem("candidatereportFilters")
if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
  const [selectAll, setSelectAll] = useState(false);

  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [workmodeOptions] = useState([
    { value: "", label: "Select Work Mode" },
    { value: "1", label: "Work from Home" },
    { value: "2", label: "Work from Office" },
    { value: "3", label: "Hybrid" },
  ]);
   const [candidateType,setCandidateType] = useState([
        {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
        {candidateTypeID:"C2C",typeName:"C2C"},
        {candidateTypeID:"W2",typeName:"W2"},
      {candidateTypeID:"1099",typeName:"1099"}]);
  const [selectedWorkMode, setSelectedWorkMode] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountryfilter, setSelectedCountry] = useState(null);
  
  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
     { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case

  ];
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
const { register, handleSubmit, formState: { errors, isSubmitting }, control, reset } = useForm();
  
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined"||value === "null..." || value === "undefined...") 
    ? "" 
    : value;
 
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "", 
    // clientStatus: "",   
    JobRoleID: "",
    SubmittedDate: null,  
    VendorGuid:"",
    CandidateType: "",
    ClientStatus: null,
  });

    const handleModalOpen = (guid,comments,clientStatus,submittedDate) => {
      console.log("123: comments :",comments, clientStatus,guid)
     
    setSelectedUserGuid(guid);
    setComments(comments);
    setSelectedStatus(clientStatus);
     setSubmittedDate(submittedDate);
    setShowDropdownModal(true);
  };

  const handleModalClose = () => {
    setShowDropdownModal(false);
  };
   
    const handleFilterChange = (selectedOption) => {
      setSelectedDateFilter(selectedOption); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        SubmittedDate: selectedOption.label, // ✅ Store label for API
      }));
    };

  const handleSelectAll = () => {
  setSelectAll(!selectAll);
  if (!selectAll) {
    // Select all candidate GUIDs
    const allGuids = candidateData.map(candidate => String(candidate.guid));
    setSelectedCandidateGuids(allGuids);
  } else {
    // Deselect all
    setSelectedCandidateGuids([]);
  }
};  
useEffect(() => {
  GetCandidateList();
  fetchJobRoles();
  fetchCountries();
  GetVendorsList();
   fetchJobPosts();
   GetUsersList();
}, [selectedCountry]); // Fetch data only once when the component mounts
const GetVendorsList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

  Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};
const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
    console.error("Error fetching job roles", error);
  }
};
const fetchCountries = async () => {
  try {
    const response = await fetch(GetCountries.APIURL,
      { headers: {    Authorization: `Bearer ${token}`,
    }}
    );
    const json = await response.json();
    
    // Format the countries for react-select
    const countryOptions = json.map((country) => ({
      value: country.countryID, // Assuming each country has a unique ID
      label: country.country, // Adjust based on API response structure
    }));

    setCountries([{ value: "", label: "Select Country" }, ...countryOptions]);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};


const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole
}));
 const handleVendorChange = (event) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        VendorGuid: event.target.value, // ✅ Store as a string
      }));
    };
const handleConfirmDeactivation = async () => {

   const params = {
      userGuid: Guid
    };

     await Axios.put(`${updateStatus.APIURL}?Guid=${candidateId}&isActive=${false}`, params,
      { headers: { Authorization: `Bearer ${token}` } }
     )
      .then((result) => 
        {
          if(result.data=='Candidate status updated successfully'){
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'DeActivated succesfully',
              showConfirmButton: false,
              timer: 2000,
            })
          }
          setCandidateData(prevData => prevData.filter(candidate => candidate.guid !== candidateId));

        setIsLoading(false);
        setShowModal(false);

      })
      .catch((error) => {
        console.log("Error" + error);
      });
    }



const handleCancel = () => {
  setShowModal(false);
};

const handleCancelSearch = () => {
  setShowFilterModal(false);
};

  const GetUsersList = () => {
    setIsLoading(true);

    const GetapiUrl = GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;

    Axios.get(GetapiUrl,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((result) => {
        setIsLoading(false);
const filteredusers = result.data?.filter(user =>
  user.countryMappings?.includes(selectedCountry)
);
       setUsersList(filteredusers || []);
      }).catch((error) => {
        console.log("Error" + error);
      });
  };

const tileConfig = [
  { title: "Total Candidates", key: "totalCandidates", bg: "bg-primary", type: "reset" },
  { title: "New", key: "new", bg: "bg-secondary", status: "New" },
  { title: "Submitted", key: "jobSubmission", bg: "bg-primary", status: "Submitted" },
  { title: "In-Progress", key: "shortlisted", bg: "bg-warning", status: "In-Progress" },
  { title: "Offers Released", key: "offersReleased", bg: "bg-success", status: "Selected" },
  { title: "Interviews Scheduled", key: "interviewsScheduled", bg: "bg-info", status: "Interview Scheduled" },
  { title: "Rejected", key: "rejected", bg: "bg-danger", status: "Rejected" },
  { title: "On Hold", key: "onHold", bg: "bg-dark", status: "On Hold" },
];




 const userEmailOptions = usersList
  ?.filter(user => user.isActive)
  .map(user => ({
    value: user.email,
    label: `${user.companyName} - ${user.firstName} `,
  }));

  const GetCandidateList = async () => {
    setIsLoading(true);

   
    const GetapiUrl = Searchfilter.APIURL;
  console.log("210",selectedCountry)

     const savedFilters = localStorage.getItem("candidatereportFilters");
  let payload;

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters);
         parsedFilters.CountryID = selectedCountry;
    setFilters(parsedFilters); // Optional: sync with UI filters

    payload = {
      json: JSON.stringify(parsedFilters),
      type: "Reports",
    };
  } else {
    // Default payload when no saved filters
    payload = {
      json: JSON.stringify({ UserGuid: Guid, CountryID: selectedCountry }),
      type: "Reports",
    };
  }


    const result = await Axios.post(GetapiUrl, payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
     .then((result) => {
  setIsLoading(false);
  if (Array.isArray(result.data)) {
  const summaryItem = result.data.find(item => item.isSummary === true);
  const actualCandidates = result.data.filter(item => !item.isSummary);
setOriginalCandidateData(actualCandidates); // save full data
 setBaseFilteredData(actualCandidates);
  setSummaryData({
          totalCandidates: summaryItem.summary.totalCandidates || 0,
          new: summaryItem.summary.new || 0,
          jobSubmission: summaryItem.summary.jobSubmission || 0,
          shortlisted: summaryItem.summary.shortlisted || 0,
          offersReleased: summaryItem.summary.offersReleased || 0,
          interviewsScheduled: summaryItem.summary.interviewsScheduled || 0,
          rejected: summaryItem.summary.rejected || 0,
          onHold: summaryItem.summary.onHold || 0,
        });

     const savedTile = sessionStorage.getItem("candidateTile") || "reset";
      setSelectedTile(savedTile); // Update UI tile

      if (savedTile === "reset") {
        setCandidateData(actualCandidates);
      } else {
        const filtered = actualCandidates.filter(
          (candidate) =>
            candidate.clientStatus?.toLowerCase() === savedTile.toLowerCase()
        );
        setCandidateData(filtered);
      }

} else {
  setCandidateData([]);
      setOriginalCandidateData([]);
      setBaseFilteredData([]);
       setData([]);  
  setSummaryData({
        totalCandidates: 0,
        new: 0,
        jobSubmission: 0,
        shortlisted: 0,
        offersReleased: 0,
        interviewsScheduled: 0,
        rejected: 0,
        onHold: 0,
      });
  setCandidateData([]);
}

})
.catch((error) => {
        console.log("Error" + error);
      });
  };
  const handleCardClick = (guid) => {
    setSelectedCandidateGuids((prev) =>
      prev.includes(guid)
        ? prev.filter((id) => id !== guid)
        : [...prev, guid]
    );
  };
  
  
 const handleSendEmail = () => {
   if (selectedCandidateGuids.length === 0) {
     Swal.fire("Please select at least one candidate.");
     return;
   }
  
   // Get full data objects
   const selectedCandidates = candidateData.filter(candidate =>
     selectedCandidateGuids.includes(candidate.guid)
   );
  
   // Save to sessionStorage
   localStorage.setItem("selectedCandidateDetails", JSON.stringify(selectedCandidates));
  
   // Navigate
   window.location.href = `/Employer/ShareReportsCandidateDetailstoSubvendor`;
 };
  
  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
    const handleJobRoleChange = (selectedOptions) => {
      const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", "); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        JobRoleID: jobRolesLabels, // ✅ Store as a string
      }));
    };
    
     const handleStatusChange = () => {
     console.log("Payload =>", { guid: selectedUserGuid, status: selectedStatus, comments });
      if(selectedStatus == null){
        Swal.fire("You can not submit without selecting any option!")
        return
      }
      setIsLoading(true)
      const payload ={
  "guid": selectedUserGuid,
  "status": selectedStatus,
  "comments": comments
      }
      Axios.post(`${UpdateCandidateClientStatus.APIURL}`,payload)
        .then((result) => {
          setIsLoading(false)
          if (result.data == 'Status updated successfully') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Updated Successfully ',
              showConfirmButton: false,
              timer: 5000
            })
            GetCandidateList();
            setShowDropdownModal(false);
          }
        }
        )
    };
    
   const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));

    
   
    
    
 const applyFilters = () => {
  const cleanedFilters = {
    ...filters,
    WorkMode: filters.WorkMode === "Select Work Mode" ? "" : filters.WorkMode,
 SubmittedDate:
      filters.SubmittedDate === "Select Date Filter" || !filters.SubmittedDate
        ? "This month"
        : filters.SubmittedDate,    CountryID: selectedCountry,

  };
  const selectedUser = usersList?.find(user => user.email === filters.SubmittedBy);

  // ✅ Remove Usertype if that user's roleID is 2
  if (selectedUser?.roleID === 2) {
    delete cleanedFilters.Usertype;
  }
  const filteredData = Object.fromEntries(
    Object.entries(cleanedFilters).filter(
      ([key, value]) =>
        value !== "" &&
        value !== null &&
        !(Array.isArray(value) && value.length === 0)
    )
  );

  localStorage.setItem("candidatereportFilters", JSON.stringify(cleanedFilters));

  const payload = {
    json: JSON.stringify(filteredData),
    type: "Reports",
  };

  Axios.post(Searchfilter.APIURL, payload,
    { headers: { Authorization: `Bearer ${token}` } }
  )
    .then((response) => {
        setShowFilterModal(false);
      if (Array.isArray(response.data)) {
        const summaryItem = response.data.find(item => item.isSummary === true);
        const actualCandidates = response.data.filter(item => !item.isSummary);

         setSummaryData({
          totalCandidates: summaryItem.summary.totalCandidates || 0,
          new: summaryItem.summary.new || 0,
          jobSubmission: summaryItem.summary.jobSubmission || 0,
          shortlisted: summaryItem.summary.shortlisted || 0,
          offersReleased: summaryItem.summary.offersReleased || 0,
          interviewsScheduled: summaryItem.summary.interviewsScheduled || 0,
          rejected: summaryItem.summary.rejected || 0,
          onHold: summaryItem.summary.onHold || 0,
        });
   setBaseFilteredData(actualCandidates);  
        setCandidateData(actualCandidates);
           setSelectedTile("reset");
      } else {
        // No Data case
      setSummaryData({
          totalCandidates: 0,
          new: 0,
          jobSubmission: 0,
          shortlisted: 0,
          offersReleased: 0,
          interviewsScheduled: 0,
          rejected: 0,
          onHold: 0,
        });
        setCandidateData([]);
         setBaseFilteredData([]);
        setSelectedTile("reset");
      }

    
    })
    .catch((error) => {
      console.error("Error applying filters:", error);
        setSummaryData({
          totalCandidates: 0,
          new: 0,
          jobSubmission: 0,
          shortlisted: 0,
          offersReleased: 0,
          interviewsScheduled: 0,
          rejected: 0,
          onHold: 0,
        });
      setCandidateData([]);
         setBaseFilteredData([]);
      setSelectedTile("reset");
    });
};

const handleTileClick = (tileStatus) => {
  setSelectedTile(tileStatus);
  sessionStorage.setItem("candidateTile", tileStatus);

  if (tileStatus === "reset") {
    setCandidateData(baseFilteredData);
  } else {
    const filtered = baseFilteredData.filter(
      (candidate) =>
        candidate.clientStatus?.toLowerCase() === tileStatus.toLowerCase()
    );
    setCandidateData(filtered);
  }
};



    const exportToCSV = async (fileName) => {
      setIsLoading(true); // Show loader while fetching data
    
      try {
        const GetapiUrl = Searchfilter.APIURL;
  
        const payload = {
          json: JSON.stringify({UserGuid: Guid,CountryID:selectedCountry}),
          type: "Reports",
    
        };
        const result = await Axios.post(GetapiUrl, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setIsLoading(false);
    
        if (!result.data || result.data.length === 0) {
          alert("No data available for export.");
          return;
        }
    
        // Map API response to formatted data
        const customHeadings = result.data.map((item) => ({
          "Full Name": item.fullName,
          "Email": item.email,
          "Mobile Number": item.mobileNumber,
          "Gender": item.gender,
          "Address": item.address,
          "Date of Birth": item.dob,
          "Job Role": item.jobRoleName,
          "Marital Status": item.maritalStatus,
          "Technical Skill": item.technicalSkill,
          "Experience": item.experience,
          "Work Mode": item.workMode,
          "Prefer Location": item.preferLocation,
          "Profile Summary": item.profileSummery,
          "Bill Rate": item.billRate,
          "Work Authorization and Validity": item.workAuthorizationandValidity,
          "Employer Name": item.employerName,
          "SSN": item.ssn,
          "Passport No": item.passportNo,
          "Two References from Recent Project": item.tworefrencesfromrecentproject,
        }));
    
        // Convert JSON to sheet
        const ws = XLSX.utils.json_to_sheet(customHeadings);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    
        // Create Blob and trigger download
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      } catch (error) {
        setIsLoading(false);
        console.error("Error exporting data:", error);
        alert("Failed to export data. Please try again.");
      }
    };
    const userTypeOptions = [
  { value: "Recruiter", label: "Recruiter" },
  { value: "Bench Sales", label: "Bench Sales" },
];

  useEffect(() => {
  const filteredData = candidateData?.filter(candidate => {
    const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();

    // If no search term
    if (!lowerSearchTerm) {
        return true; 
    }

    // Determine search logic based on operators
    let searchTerms;
    let isAndSearch = false;
  
    if (lowerSearchTerm?.includes(' + ') || lowerSearchTerm?.includes(' and ')) {
        searchTerms = lowerSearchTerm?.split(/\s*\+\s*|\s+and\s+/);
        isAndSearch = true; // ALL terms must match
    } else if (lowerSearchTerm.includes(' or ')) {
        searchTerms = lowerSearchTerm?.split(/\s+or\s+/);
        isAndSearch = false; // At least one term must match
    } else {
        searchTerms = [lowerSearchTerm]; // Treat it as a single phrase
        isAndSearch = false;
    }
  
    // Convert search terms to lowercase and trim spaces
    searchTerms = searchTerms.map(term => term.trim());
  
    // Function to check if a field contains the *entire search term*
    const fieldMatchesTerm = (term) => {
        return [
            candidate.fullName,
            candidate.technicalSkill,
            candidate.jobRoleName,
            candidate.preferLocation,
            candidate.address,
            candidate.profileSummary,
            candidate.workAuthorizationandValidity,
            candidate.email
        ].some(field => field?.toLowerCase()?.includes(term)) ||
        (candidate.experience !== undefined && 
         (candidate.experience?.toString()?.includes(term) || `${candidate.experience} years`?.includes(term)));
    };
  
    // Apply AND / OR search logic
    const matchesSearch = isAndSearch
        ? searchTerms.every(fieldMatchesTerm) // Require all terms to match (AND search)
        : searchTerms.some(fieldMatchesTerm); // At least one term matches (OR search)

    return matchesSearch;
  });
  if (filteredData.length === 0) {
    setHasNoData(true);
    setData([]); // clear the UI
    setPageCount(0);
    return;
  } else {
    setHasNoData(false);
  }
  const getExperienceText = (experience) => {
    if (!experience) return '';
    return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
  };
    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType =='grid' ? slice.map((data) => {
                   const isSelected = selectedCandidateGuids.includes(String(data.guid));

      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
             <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 600, height: 600, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 100 }}>
                  <div className='row'>
                    <div className='col-4'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                        <img alt="Profile Photo" src={(data?.photo === "null") || (data.photo === null )?defaultimg : data?.photoURL} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                        {/* <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} /> */}

                      </OverlayTrigger>
                    </div>
                    <div className='col-8'>
                 
                
  
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:250}}>
                                 
                 
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>               
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{ selectedCountry == 2 ? "PayRate" : "Current CTC" }</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-dollar-sign" aria-hidden="true"></i>{safeValue(data.payRate)}</p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>   { selectedCountry == 2 ? "BillRate" : "Expected CTC" } </Tooltip>)}>
                   <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-money-bill" aria-hidden="true"></i> {safeValue(data.billRate)}</p>
                 </OverlayTrigger>
                  {/* {data.preferLocation!==null && data.preferLocation!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Country</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-map-marker" aria-hidden="true"></i> {data.preferLocation}  </p>
                  </OverlayTrigger>)} */}
                  {data.experience!==null && data.experience!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Experience</Tooltip>)}>
        <p style={{ fontSize: 14 }}><i className="fa fa-briefcase icons" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} ></i> {getExperienceText(data.experience)}</p>
                  </OverlayTrigger>)}
                  {data.vendorName!==null && data.vendorName!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Name - Company Name</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {safeValue(data.vendorName)}  - {safeValue(data.vendorCompanyName)} </p>
                  </OverlayTrigger>)}
       <div className="d-flex align-items-center">       
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Status</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i>{safeValue(data.clientStatus)}</p>
                </OverlayTrigger>
                 <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Status</Tooltip>}>
                                                    <FontAwesomeIcon icon="fas fa-edit" onClick={() => handleModalOpen(data.submissionGuid,data.comments,data.clientStatus,data.submittedDate)} style={{ marginLeft: 10, marginTop: -14, color: "#00a7ac", fontSize: 14 }} />
                                                  </OverlayTrigger>
                                              
                                                 
</div>    

  <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Submitted Date ({selectedCountry == 2 ? "MM/DD/YYYY" : "DD/MM/YYYY"})
            </Tooltip>
          )}
        >
          <p style={{ fontSize: 14 }}>
            <i
              style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
              className="fas fa-calendar-alt"
              aria-hidden="true"
            ></i>
             {data.clientStatus !== "New" &&
    (data.submittedDate ? new Date(data.submittedDate).toLocaleDateString(
        selectedCountry == 2 ? "en-US" : "en-GB"
      ) : "")
  }
          </p>
        </OverlayTrigger>  
 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> <span
        dangerouslySetInnerHTML={{
          __html: safeValue(data.comments)
        }}
      /></Tooltip>)}>
                     <p className="text-para">
      <i className="fa fa-building icons"></i>
      <span
        dangerouslySetInnerHTML={{
          __html: safeValue(substring_str(data.comments))
        }}
      />
    </p>
                  </OverlayTrigger>
                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Title</Tooltip>)}>
                                        <p style={{ fontSize: 14, textAlign: 'justify' }}>
                                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-user-tie" aria-hidden="true"></i>
                                      {safeValue(data.jobTitle)}
                                      </p>
                                         </OverlayTrigger>
                </div>
                <div   className={`card-footer text-center`} 
  style={{ background: "none" }}
>                 
  
                    <Link style={{ }} to={"/Employer/ReportViewCandidateDetailsByCandidateGUid?Submissionid=" + data.submissionGuid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                      
                    </Link>
                    {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Send Email</Tooltip>}>
              <span>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCardClick(data.guid)}
                />
              </span>
            </OverlayTrigger> */}
                    
                </div>
                
              </div>
        </div>
      )  })
      :
    
      <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                            <table
  className="table"
  style={{
 //   minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
 


  }}
>
  <thead>
    <tr>
      <th style={{ padding: "4px" }}>Full Name</th>
        <th style={{ padding: "4px" }}>Job Title</th>
      <th style={{ padding: "4px" }}>Job Role</th>
    
      <th style={{ padding: "4px" }}>Mobile Number</th>
      <th style={{ padding: "4px" }}>Email</th>
      {/* <th style={{ padding: "4px" }}>Country</th> */}
      <th style={{ padding: "4px" }}>Experience</th>
   
     { selectedCountry == 2 ?<th style={{ padding: "4px" }}>PayRate</th>: <th style={{ padding: "4px" }}> Current CTC</th>}

     { selectedCountry == 2 ? <th style={{ padding: "4px" }}>Bill Rate</th>: <th style={{ padding: "4px" }}>Expected CTC</th>}
        <th style={{ padding: "4px" }}>Client Name - Company Name</th>
         <th style={{ padding: "4px" }}>Client Status</th> 
      <th style={{ padding: "4px" }}>Comments</th>
        <th style={{ padding: "4px" }}> Submitted Date ({selectedCountry == 2 ? "MM/DD/YYYY" : "DD/MM/YYYY"})</th>
      <th style={{ padding: "4px",width:100 }}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {slice?.map((data, index) => {
             const isSelected = selectedCandidateGuids.includes(String(data.guid));

                return (
      <tr key={index}  style={{marginBottom:'2px'}}>
        <td style={{ padding: "4px" }}>{safeValue(data.fullName)}</td>
          <td style={{ padding: "4px" }}>{safeValue(data.jobTitle)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.jobRoleName)}</td>
      
        <td style={{ padding: "4px" }}>{safeValue(data.mobileNumber)}</td>
        <td style={{ padding: "4px"}}>{safeValue(data.email)}</td>
        {/* <td style={{ padding: "4px"}}>{data.preferLocation}</td> */}
        <td style={{ padding: "4px"}}>{safeValue(data.experience)}</td>
          <td style={{ padding: "4px" }}>{safeValue(data.payRate)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.billRate)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.vendorName)} - {safeValue(data.vendorCompanyName)} </td>
        
   <td style={{ padding: "4px",  borderBottom:'0px' }} className="d-flex align-items-center">
  {safeValue(data.clientStatus)}
  
    <FontAwesomeIcon
      icon="fas fa-edit"
      onClick={() => handleModalOpen(data.submissionGuid,data.comments,data.clientStatus,data.submittedDate)}
      style={{ marginLeft: 8, color: "#00a7ac", cursor: "pointer" }}
    />
 
</td>
  <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
           <span  dangerouslySetInnerHTML={{ __html: safeValue(data.comments) }}></span>
            </Tooltip>
          )}
        >
     <td dangerouslySetInnerHTML={{ __html: safeValue(substring_str(data.comments)) }}></td>
        </OverlayTrigger>
       
<td>
  {data.clientStatus !== "New" &&
    (data.submittedDate ? new Date(data.submittedDate).toLocaleDateString(
        selectedCountry == 2 ? "en-US" : "en-GB"
      ) : "")
  }
</td>
  
        <td style={{ padding: "4px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "center",
            }}
          >
            {/* Example of responsive button grouping */}
            {[
            //   {
            //     icon: "fa-clone",
            //     tooltip: "Replicate Candidate",
            //     to: `/Employer/ReplicateBenchCandidate?guid=${data.guid}`,
            //   },
            //   {
            //     icon: "fa-edit",
            //     tooltip: "Edit",
            //     to: `/Employer/EditBenchCandidate?guid=${data.guid}`,
            //   },
              {
                icon: "fa-eye",
                tooltip: "View",
                to: `/Employer/ReportViewCandidateDetailsByCandidateGUid?Submissionid=${data.submissionGuid}`,
              },
            //   {
            //     icon: "fa-share-alt",
            //     tooltip: "Share",
            //     to: `/Employer/ShareDetailstoVendor?guid=${data.guid}`,
            //   },
            //   {
            //     icon: "fa-envelope",
            //     tooltip: "Send Email",
            //     to: `/Employer/SendEmail?fullName=${data.fullName}`,
            //   },
            ].map((btn, i) => (
              <Link key={i} to={btn.to}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip id="tooltip" {...props}>
                      {btn.tooltip}
                    </Tooltip>
                  )}
                >
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      padding: "4px",
                    }}
                  >
                    <i
                      className={`fa ${btn.icon}`}
                      aria-hidden="true"
                      style={{ fontSize: 14, color: "#00a7ac" }}
                    ></i>
                  </button>
                </OverlayTrigger>
              </Link>
            ))}
              {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Send Email</Tooltip>}>
              <span>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCardClick(data.guid)}
                style={{
                width: 16,
                height: 16,
                cursor: "pointer",
                marginTop: '6px',
                marginLeft: '2px',
                accentColor: '#00a7ac !important', // ✅ ensures tick is visible in modern browsers
               appearance: 'auto !important' // ✅ resets to system default
              }}
                />
              </span>
            </OverlayTrigger> */}
            
          </div>
        </td>
      </tr>
   )})}
  </tbody>
</table>

                            </div>
      
  

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm,startDate,endDate,candidateData, perPage,viewType,selectedCandidateGuids]);
useEffect(() => {
  const savedFilters = JSON.parse(localStorage.getItem("candidatereportFilters"));

  // Optional: Check for existence and apply to state or variables if needed
  if (savedFilters) {
    console.log("Loaded filters:", savedFilters);

    // Example: if you have state like setSearchTerm, setStartDate, etc.
    if (savedFilters.searchTerm) {
      setSearchTerm(savedFilters.searchTerm);
    }
    if (savedFilters.startDate) {
      setStartDate(savedFilters.startDate);
    }
    if (savedFilters.endDate) {
      setEndDate(savedFilters.endDate);
    }
    // ... any other filters
  }

  // Continue with your filtering logic...

}, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  const handleClick = () => {
    const finalURL = `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`;
    navigator.clipboard.writeText(finalURL)
      .then(() => Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Copied',
        showConfirmButton: false,
        timer: 1000,
      }))
      
      
      .catch(err => console.error('Failed to copy URL: ', err));
  };


  const handleRefresh=()=>{
    setCandidateData(baseFilteredData); 
      setSearchTerm("")
    setFilters({
       UserGuid: Guid,
    FullName: "",
    Email: "", 
    ClientStatus: null,   
    JobRoleID: "",
    SubmittedDate: null,  
    VendorGuid:null,
    CandidateType:"",
   jobTitleID: null,
   Usertype: null
    });
     reset({
    vendorCompanyName: "", // field name in `register()`
    ClientStatus: "",       // field name in `register()`
    candidateTypeID: ""
  });
     localStorage.removeItem("candidatereportFilters");
    GetCandidateList();
  }

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
        <div><h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>
      Reports - Submissions
  </h2></div>
<div style={{display:'flex',justifyContent:'space-between'}}>

              <div>

          
                               <OverlayTrigger placement="bottom" overlay={<Tooltip>Overall Statistics</Tooltip>}>
  <button
    className="btn btn-primary mr-3"
    onClick={() => navigate("/Employer/OverallRecruiterstatistics")}  // 👈 navigate to new screen
    style={{ backgroundColor: "#00a7ac" }}
  >
<i className="fas fa-chart-bar" style={{ color: '#fff', cursor: 'pointer' }}></i>  </button>
</OverlayTrigger>

              
            {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
              )}
              {showIcon === 'list' && (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                  <button
                    className="btn btn-primary mr-3"
                    onClick={() => handleViewToggle('grid')}
                    style={{ backgroundColor: "#00a7ac" }}
                  >
                    <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                  </button>
                </OverlayTrigger>
              )}
           </div>
         
  </div>

        </div>
        <div>
 
        <div className="row d-flex justify-content-between mt-3">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role or Country or Address</Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technical Skill or Email or Role or Address"
        className="form-control mt-3"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
   
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>{ appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
    )}>
    <button className="btn btn-primary mt-3 mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
    <i className="fas fa-filter"></i>    { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
    </button>
    </OverlayTrigger>
    </Link>
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i> Reset Filter
    </button>
    </OverlayTrigger>
    </Link>
   
  </div>
</div>
<div className="d-flex justify-content-between flex-nowrap overflow-auto gap-3 mt-2 mb-3">
  {tileConfig.map((tile, index) => (
      <div key={index} style={{ flex: "0 0 11%", minWidth: 100, marginBottom: 12 }}>
      <div
      className={`card text-white ${tile.bg} shadow`}
        style={{
          cursor: "pointer",
          height: 65,
          borderRadius: 12,
          padding: "4px 6px",
          minWidth: 100,
           border: selectedTile === tile.status || (tile.type === "reset" && selectedTile === "reset")
  ? "2px solid black"
  : "none",
  }}
       
        onClick={() => {
          if (tile.type === "reset") {
            setCandidateData(
              baseFilteredData);
            setSelectedTile("reset");
          } else {
            handleTileClick(tile.status);
          }
        }}
      >
        <div className="card-body p-2 d-flex flex-column justify-content-center align-items-center">
          <h6 className="card-title mb-1 text-center" style={{ fontSize: "14px" }}>
            {tile.title}
          </h6>
          <p className="card-text mb-0" style={{ fontSize: "10px", fontWeight: "bold" }}>
            {summaryData[tile.key] ?? 0}
          </p>
        </div>
      </div>
    </div>
  ))}
</div>







              </div>

        <hr />
        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>
       <div>
                <input 
                  type="checkbox" 
                  checked={selectAll} 
                  onChange={handleSelectAll} 
                  style={{ marginRight: '10px' }} 
                />
                <span style={{marginRight: '10px',  color: '#333', }}>Select All</span>
            </div>      
   {selectedCandidateGuids.length > 0 && (
  <button className="btn btn-primary" onClick={handleSendEmail} style={{ height: 45,backgroundColor: "#00a7ac" }}>
     
    Send Email {selectedCandidateGuids.length} <i className="fas fa-arrow-right" style={{ marginLeft: 5 }}></i>
  </button>
)}
</div> */}
     {isLoading ? (
            <center><LoadingSpinner /></center>
          ) : (
            <>
   {hasNoData ? (
    <div className="pb-5 text-center">
      <img
        title="No Data"
        className="no-data-img"
        alt="no-data-img"
        src={nodataimg}
        style={{ height: 370 }}
      />
    </div>
  ) : (
    <div className="row mt-5 pb-3">
      {data}
    </div>
  )}
  
  
            </>
          )}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

<Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this candidate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
         </Modal.Header>
        <Modal.Body>
          <div className='row'>
                <div className='col-6'>  
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Client name</Tooltip>)}>
                    <select
                                            {...register("vendorCompanyName", { required: "Client Name Required" })}
                                            className={`form-control mt-3 ${errors.vendorCompanyName ? 'is-invalid' : ''}`}
                                           style={{height:50 ,borderRadius:15,fontSize:12}}
                                            onChange={handleVendorChange}
                                             value={filters.VendorGuid || ""}
                                        >
                                            <option value="">Select Client Name</option>
                                            {vendorData.map((vendor, index) => (
                                                <option key={index} value={vendor.vGuid}>{vendor.vendorName} - {vendor.vendorCompanyName}</option>
                                            ))}
                    </select>  
                    </OverlayTrigger>
                     {/* <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Status</Tooltip>)}>
                    <select  {...register("clientStatus")} className={`form-control mt-3`}
                    style={{height:50 ,borderRadius:15,fontSize:12}} 
                       onChange={(event) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      ClientStatus: event.target.value, // ✅ Store as a string
    }))
  }>
                <option value="">Select Candidate Status</option>
                    <option value="New">New</option>
                    <option value="Submitted">Submitted</option>
                    <option value="In-Progress">In-Progress</option>
                    <option value="Selected">Selected</option>
                    <option value="Rejected">Rejected</option>
                    </select>
                                         </OverlayTrigger>                */}
                                
                  

                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Date Filter</Tooltip>)}>    
                    
                                    <Select
                        options={dateFilterOptions}
                        placeholder="Select Date Filter"
                        value={dateFilterOptions.find(option => option.label === filters.SubmittedDate) || null}
                        onChange={handleFilterChange}
                        className="mt-3"
                        styles={{
                            control: (provided) => ({
                            ...provided,
                            height: 50,
                            borderRadius: 10,
                            fontSize: "12px",
                            }),
                            placeholder: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            }),
                            singleValue: (provided) => ({
                            ...provided,
                            textAlign: "left",
                            fontSize: "12px",
                            
                            }),
                        }}
                        />
                    </OverlayTrigger>
                      <OverlayTrigger
            placement="bottom"
            overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Title</Tooltip>}
          >
            <div className="mt-4">
              <Select
  options={jobTitleOptions}
  placeholder="Select Job Title"
  className="mt-3"
value={
    jobTitleOptions.find(option => option.value === filters.jobTitleID) || null
  }  
  onChange={(selectedOption) => {
    setFilters(prev => ({
      ...prev,
      jobTitleID: selectedOption ? selectedOption.value : null
    }));
  }}
  styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 10,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  }}
/>

            </div>
          </OverlayTrigger>
          
        <OverlayTrigger placement="bottom" overlay={<Tooltip>Select User</Tooltip>}>
  <div className="mt-4">
    <Select
      options={userEmailOptions}
      placeholder="Select User"
      value={
        userEmailOptions.find((option) => option.value === filters.SubmittedBy) || null
      }
      onChange={(selectedOption) =>
        setFilters((prevFilters) => ({
          ...prevFilters,
          SubmittedBy: selectedOption ? selectedOption.value : ""
        }))
      }
      isClearable
      styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 10,
          fontSize: "12px",
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
        singleValue: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
      }}
    />
  </div>
</OverlayTrigger>

                   
                </div>
                <div className='col-6'>
             
    
                <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Type</Tooltip>)}>
                    <select  {...register("candidateTypeID")} className={`form-control mt-3`}
                    style={{height:50 ,borderRadius:15,fontSize:12}} 
                       onChange={(event) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      CandidateType: event.target.value, // ✅ Store as a string
    }))
  }
   value={filters.CandidateType || ""}
  >
            <option value="">Select Candidate Type</option>
{
  candidateType.map((item,index)=>
  {
    return(

   <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>

    );
  }
  
  )
}
                    </select>
                                         </OverlayTrigger>   
              <Select
            options={jobRoleOptions}
            isMulti
            placeholder="Select Job Roles"
            className="mt-3"
            value={jobRoleOptions.filter(option => 
              filters.JobRoleID?.split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
            )}
            onChange={handleJobRoleChange}
            styles={{
              control: (provided) => ({
                ...provided,
                height: 115,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
          />
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Select Designation Type</Tooltip>}>

<div className="mt-4">
  <Controller
    name="Usertype"
    control={control}
    render={({ field }) => (
      <Select 
        {...field}
        options={[
          { value: "Recruiter", label: "Recruiter" },
          { value: "Bench Sales", label: "Bench Sales" }
        ]}
        placeholder="Select Designation Type"
        
     value={
    userTypeOptions.find((option) => option.value === filters.Usertype) || null
  }
  onChange={(selectedOption) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      Usertype: selectedOption ? selectedOption.value : ""
    }))
  }
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: 50,
            borderRadius: 15,
             fontSize: "12px",
            borderColor: errors.Usertype ? 'red' : provided.borderColor,
          }),
          placeholder: (provided) => ({
            ...provided,
             fontSize: '12px', // 👈 Smaller font size
            // color: '#999',     // Optional: lighter color for placeholder
          }),
          singleValue: (provided) => ({
            ...provided,
            fontSize: '12px',
          }),}}
        className={` basic-form ${errors.Usertype ? 'is-invalid' : ''}`}
        
      />
    )}
  />

</div>
</OverlayTrigger>
                </div>
          </div>
         
        </Modal.Body>
        <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
      </Modal>
       <Modal show={showDropdownModal} onHide={handleModalClose} centered   dialogClassName="custom-inline-width">
                <Modal.Header closeButton>
                  <Modal.Title style={{fontSize:20}}>Update Candidate Status</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{width:700}}>
                  {["New","Submitted","In-Progress", "Interview Scheduled","On Hold","Selected","Rejected" ].map((status) => (
                    <Button
                    key={status}
                     size="sm"
                     variant={selectedStatus === status ? "primary" : "outline-primary"} 
                    className="w-100 mb-2"
                    onClick={() => setSelectedStatus(status)}
                  >
                    {status}
                  </Button>
                  
                  ))}
        
             <div style={{ marginBottom: 20 }}>
   {selectedTile!='New' &&   <div
    style={{
      background: "#f9f9f9",
      padding: "6px 10px",
      border: "1px solid #ddd",
      borderBottom: "none",
      borderRadius: "6px 6px 0 0",
      fontSize: 14,
      color: "#555"
    }}
  >
    <i
      style={{ fontSize: 14, color: "#00a7ac", marginRight: 8 }}
      className="fas fa-calendar-alt"
    ></i><b>Submitted Date({selectedCountry == 2 ? "MM/DD/YYYY" : "DD/MM/YYYY"}): 
     {submittedDate
    ? new Date(submittedDate).toLocaleDateString(
        selectedCountry == 2 ? "en-US" : "en-GB"
      )
    : ""}</b>
  </div>
}
        

  <ReactQuill
    value={comments}
    onChange={setComments}
    placeholder="Comments"
    style={{ height: 180 }}
  />
</div>

                      {/* <textarea type="text" style={{height:100}} title='' placeholder='Comments'
            onChange={(e)=>setComments(e.target.value)} 
        value =  {safeValue(comments)}
           className={`form-control basic-form mt-3 `} ></textarea> */}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => {
    console.log("Clicked Submit");
    handleStatusChange();
  }}>
                    Submit
                  </Button>
                  <Button variant="secondary" onClick={handleModalClose}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
              <style>
{`
  .custom-inline-width {
    max-width: 700px !important;
    width: 100%;
  }
`}
</style>
      </div>
    </ConsultantLayout>
  );
}

export default Reports;


